exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-icon{padding:0 14px}.example-spacer{flex:1 1 auto}.example-container{display:flex;flex-direction:column;max-width:100%;margin:0}.version_style{position:absolute;bottom:1px;right:5px;color:#fff;font-size:small}", ""]);

// exports
